import L from 'leaflet';
import transparentImg from '../../icons/transparent.png';
import { Marker, Tooltip } from 'react-leaflet';
import { StyledUserTotalTooltip } from '../../Styled';
import { useMapStore } from 'contexts/RootStore.context';
import { BuildingFeature } from 'types/venue';
import { useMemo } from 'react';

type UsersTotalCountProps = {
  buildingFeature: BuildingFeature;
};
export default function UsersTotalCount({ buildingFeature }: UsersTotalCountProps) {

  const {
    selectedBuildingId,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    users, // this should be here to force re-render on changes of users
    getBuidlingUsersCount } = useMapStore()

  const displayPoint: any = [...buildingFeature.properties.display_point.coordinates].reverse(); // reversed to correct order
  const buildingIsSelected = buildingFeature.id === selectedBuildingId

  const customIcon = new L.Icon({
    iconUrl: transparentImg, // 1px alpha image to show nothing.
    iconSize: new L.Point(0, 0),
  });

  const usersCount = useMemo(() => {
    return getBuidlingUsersCount(buildingFeature.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users, users.length])

  // only show tooltip if count is over 0 and building is not selected.
  if (usersCount === 0 || buildingIsSelected) {
    return null
  }

  return (
    <Marker icon={customIcon} position={displayPoint}>
      <Tooltip
        className="tooltip-user-total"
        permanent
        opacity={1}
        direction="bottom"
        offset={[40, 15]}
      >
        <StyledUserTotalTooltip id={`users-total-count-${buildingFeature.id}`}>
          {usersCount}
        </StyledUserTotalTooltip>
      </Tooltip>
    </Marker>
  )
}
